class ClaroluzValidateEvent {
    constructor() {
        let event = new CustomEvent('claroluz_validate', { detail: null });
        document.dispatchEvent(event);
    }
}

//removeIf(production)
export default ClaroluzValidateEvent;
//endRemoveIf(production)